import React from 'react';
import {NavLink} from "react-router-dom";
import { PROJECT_TAB_LABELS, type ProjectGallerySlug } from '../../data/projectGallery';

const SLUGS: ProjectGallerySlug[] = ['construction', 'kitchens', 'bathrooms', 'full-home', 'extensions', 'outdoors', 'roofing'];

function StateTabs() {
  return (
    <div className="flex flex-wrap justify-center mx-auto max-w-5xl gap-2 mt-8 px-4">
      {SLUGS.map((slug) => (
        <NavLink
          key={slug}
          to={`/projects/${slug}`}
          className={({isActive}) =>
            isActive
              ? 'text-sm sm:text-base font-semibold text-accent border-b-2 border-accent pb-1 px-3'
              : 'text-sm sm:text-base font-medium text-slate-500 hover:text-navy pb-1 px-3 transition-colors'
          }
        >
          {PROJECT_TAB_LABELS[slug]}
        </NavLink>
      ))}
    </div>
  );
}

export default StateTabs;
